<template>
  <div class="history-container">
    <div v-if="isLoading" class="loading">
      <b-spinner></b-spinner>
    </div>
    <div v-else class="entries-container">
      <div class="entry">
        <div class="entry-header-container">
          <div class="entry-header">
            <span>Current</span>
            <span class="show-btn" @click="toggleEntry(currentVersion)">Show/Hide</span>
          </div>
        </div>
        <div class="entry-content" v-if="currentVersion.show">
          <div v-html="currentVersion.content"></div>
        </div>
      </div>
      <div class="entry" v-for="entry in sortedEntries" :key="entry._id">
        <div class="entry-header-container">
          <div class="entry-header">
            <span>Created at {{ entry.timestamp | toDateString }}</span>
            <span class="show-btn" @click="toggleEntry(entry)">Show/Hide</span>
          </div>
          <div class="entry-actions">
            <div class="action-btn" title="Restore entry" @click="confirmRestore(entry)">
              <font-awesome-icon :icon="['fas', 'upload']" />
            </div>
            <div class="action-btn borderless" title="Delete entry" @click="confirmDelete(entry)">
              <font-awesome-icon :icon="['fas', 'trash']" color="red" />
            </div>
          </div>
        </div>
        <div class="entry-content" v-if="entry.show">
          <div v-html="entry.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "ArticleHistory",
  data() {
    return {
      isLoading: true,
      articleId: null,
      currentVersion: null,
      entries: []
    };
  },
  computed: {
    sortedEntries() {
      return this.entries.toSorted((a, b) => {
        return b.timestamp - a.timestamp;
      });
    },
    baseAPIPath() {
      return `${this.$route.params.productId}/${this.$route.params.appId}/${this.$route.params.sectionId}/${this.$route.params.articleId}`;
    }
  },
  methods: {
    async fetchEntries() {
      try {
        this.isLoading = true;
        const res = await axios.get(`${this.$route.path}`);
        this.currentVersion = res.data.current;
        this.entries = res.data.history;
      }
      catch(err) {
        console.error(err);
      }
      finally {
        this.isLoading = false;
      }
    },
    toggleEntry(inEntry) {
      if(!inEntry.show) {
        this.$set(inEntry, "show", true);
      }
      else {
        inEntry.show = !inEntry.show;
      }
    },
    async confirmRestore(inEntry) {
      try {
        this.isLoading = true;
        const d = new Date(inEntry.timestamp);
        const dateString = `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`
        const q = `Restore article to version from ${dateString}?`
        const res = confirm(q);
        
        if(res) {
          // restore entry
          await axios.put(`${this.baseAPIPath}/history/restore/${inEntry._id}`);
        }
      }
      catch(err) {
        console.error(err);
      }
      finally {
        this.fetchEntries();
        this.isLoading = false;
      }
    },
    async confirmDelete(inEntry) {
      try {
        this.isLoading = true;
        const d = new Date(inEntry.timestamp);
        const dateString = `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`
        const q = `Delete entry from ${dateString}?`
        const res = confirm(q);
        
        if(res) {
          // delete entry
          await axios.delete(`${this.baseAPIPath}/history/delete/${inEntry._id}`);
        }
      }
      catch(err) {
        console.log(err);
      }
      finally {
        this.fetchEntries();
        this.isLoading = false;
      }      
    } 
  },
  watch: {
    $route: {
      handler(to) {
        if(to.params && to.params.internalId && to.params.internalId !== this.articleId) {
          this.articleId = to.params.internalId;
          this.fetchEntries();
        }
      },
      immediate: true,
      deep: true
    }
  },
  filters: {
    toDateString(inValue) {
      const d = new Date(inValue);
      return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
    }
  }
};
</script>

<style scoped>
.history-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.entries-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px;
  width: 100%;

  .entry {
    width: 100%;

    .entry-header-container {
      display: flex;
      gap: 5px;

      .entry-header {
        flex-grow: 1;
        display: flex;
        justify-content: space-between;
        background-color: #CCCCCC;
        border: 1px solid rgba(0, 0, 0, 0.5);
        padding: 5px;
        font-weight: bold;
        
        .show-btn {
          cursor: pointer;
          
          &:hover {
            text-decoration: underline;
          }
        }
      }
  
      .entry-actions {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;

        .action-btn {
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 20px;
          width: 20px;
          height: 20px;
          overflow: hidden;
          border: 1px solid #000;

          &.borderless {
            border: unset;
          }

          &:hover {
            box-shadow: 0px 0px 10px 2px #388C75;
          }
        }
      }
    }

    .entry-content {
      padding: 10px;
      border: 1px solid rgba(0, 0, 0, 0.5);
    }
  }
}
</style>